import $ from "jquery";
import { REDIRECT_LINK, LOCALSTORAGE_KEY } from "../constants/constants";
import { NotificationManager } from 'react-notifications';

export const send = data => {
  try {
    $.ajax({
      url: "https://api.mm-mannhart.ch/api/document/doc-create",
      data: data,
      method: "POST",
      success: function(response) {
        const responseObject = JSON.parse(response);
        if (responseObject.code === "200") {
          localStorage.removeItem(LOCALSTORAGE_KEY);
          redirect(REDIRECT_LINK);
        } else {
            NotificationManager.error("Etwas stimmt nicht.")
        }
      },
      error: function(response) {
          NotificationManager.error("Etwas stimmt nicht.")
      }
    });
  } catch (err) {
    NotificationManager.error("Etwas stimmt nicht.")
    console.log("error", err);
  }
};

function redirect(url) {
  const ua = navigator.userAgent.toLowerCase(),
    isIE = ua.indexOf("msie") !== -1,
    version = parseInt(ua.substr(4, 2), 10);

  // Internet Explorer 8 and lower
  if (isIE && version < 9) {
    const link = document.createElement("a");
    link.href = url;
    document.body.appendChild(link);
    link.click();
  }

  // All other browsers can use the standard window.location.href (they don't lose HTTP_REFERER like Internet Explorer 8 & lower does)
  else {
    window.location.href = url;
  }
}



// WEBPACK FOOTER //
// ./src/actions/send.js